import axios from "axios";
import { Constants } from "../utils/Constants";

export function importarPlacas(events) {
    return axios.post(`${Constants.baseUrl}/contrato/importar-placas`, events);
}

export function importarAlteracaoMassa(form) {
    return axios.post(`${Constants.baseUrl}/contrato/importar-alteracao-massa`, form);
}

export function getKanban(events) {
    return axios.post(`${Constants.baseUrl}/contrato/kanban`, events);
}

export function getDataTable(events) {
    return axios.post(`${Constants.baseUrl}/contrato/list`, events);
}

export function getDataTableAll(events) {
    return axios.post(`${Constants.baseUrl}/contrato/list-all`, events);
}

export function get(id) {
    return axios.get(`${Constants.baseUrl}/contrato/${id}`);
}

export function update(form, id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}`, form);
}

export function create(form) {
    return axios.post(`${Constants.baseUrl}/contrato`, form);
}

export function cancelar(form) {
    return axios.post(`${Constants.baseUrl}/contrato/cancelar`, form);
}

export function alterarStatusGrupo(form) {
    return axios.post(`${Constants.baseUrl}/contrato/alterar-status`, form);
}

export function aprovar(id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}/aprovar`);
}

export function reprovar(form, id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}/reprovar`, form);
}

export function trocarTitularidade(form, id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}/trocar-titularidade`, form);
}

export function analise(form, id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}/analise`, form);
}

export function reativar(id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}/reativar`);
}

export function getSimpleList(data) {
    return axios.get(`${Constants.baseUrl}/contrato/simpleList`, { params: data });
}

export function simpleListByVeiculo(data) {
    return axios.get(`${Constants.baseUrl}/contrato/simpleList/veiculo`, { params: data });
}

export function refazerContrato(form, id) {
    return axios.post(`${Constants.baseUrl}/contrato/${id}/refazer`, form);
}
